import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "c-hero-banner" }
const _hoisted_2 = { class: "c-hero-banner__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#tp-hero" }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.image)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "o-anim-fade-300",
            mode: "out-in",
            appear: ""
          }, {
            default: _withCtx(() => [
              (_ctx.image)
                ? (_openBlock(), _createBlock(_component_ResponsiveImage, {
                    key: _ctx.image.url,
                    "image-url": _ctx.image.url,
                    "aspect-ratio": { 'max-sm': 7/4, 'default': 16/5},
                    lazy: false,
                    focus: _ctx.image.focus,
                    zoom: _ctx.image.zoom,
                    "focus-points": _ctx.image.focusPoints,
                    alt: _ctx.title,
                    "bg-color": _ctx.image.hexCode,
                    "original-height": _ctx.image.height,
                    "original-width": _ctx.image.width,
                    flip: _ctx.image.flip,
                    "cache-bust": _ctx.image.cachebust
                  }, null, 8, ["image-url", "focus", "zoom", "focus-points", "alt", "bg-color", "original-height", "original-width", "flip", "cache-bust"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            name: "c-hero-banner__title-anim",
            mode: "out-in",
            appear: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("h1", {
                key: _ctx.title,
                class: _normalizeClass(["c-hero-banner__title text-white", {'text-shadow': _ctx.scrim}])
              }, _toDisplayString(_ctx.title), 3))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}